import { apiUrl } from './api';

/**
 * Grava o layout da home Experiências (app cliente) no Dynamo via API.
 * Com `ADMIN_API_KEY` na API, envie `VITE_ADMIN_API_KEY` no admin (.env).
 */
export async function putClienteHomeLayoutToApi(body: unknown): Promise<{ ok: true } | { ok: false; error: string }> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const key =
    typeof import.meta.env.VITE_ADMIN_API_KEY === 'string' ? import.meta.env.VITE_ADMIN_API_KEY.trim() : '';
  if (key) headers['X-Admin-Key'] = key;

  try {
    const res = await fetch(apiUrl('/api/admin/cliente-home-layout'), {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    });
    const text = await res.text();
    if (!res.ok) {
      let msg = text || `Erro ${res.status}`;
      try {
        const j = JSON.parse(text) as { message?: string };
        if (j?.message) msg = j.message;
      } catch {
        /* keep msg */
      }
      return { ok: false, error: msg };
    }
    return { ok: true };
  } catch (e) {
    const msg = e instanceof Error ? e.message : 'Falha de rede';
    return { ok: false, error: msg };
  }
}
